import React from "react";
import { useWindowWidth } from "../../breakpoints";
import { BookADemo } from "../../components/BookADemo";
import { Comparison } from "../../components/Comparison";
import { Component } from "../../components/Component";
import { Component2 } from "../../components/Component2";
import { ComponentWrapper } from "../../components/ComponentWrapper";
import { Contacts } from "../../components/Contacts";
import { DivWrapper } from "../../components/DivWrapper";
import { ExploreOther } from "../../components/ExploreOther";
import { Frame } from "../../components/Frame";
import { FreeTrial } from "../../components/FreeTrial";
import { FreeTrialButton } from "../../components/FreeTrialButton";
import { FtbAnima } from "../../components/FtbAnima";
import { GetADemo } from "../../components/GetADemo";
import { HamburgerMenu } from "../../components/HamburgerMenu";
import { Login } from "../../components/Login";
import { NavComparison } from "../../components/NavComparison";
import { NavFreeTrial } from "../../components/NavFreeTrial";
import { NavLogin } from "../../components/NavLogin";
import { NavPricing } from "../../components/NavPricing";
import { NavSolutions } from "../../components/NavSolutions";
import { NavWhyIntelead } from "../../components/NavWhyIntelead";
import { Pricing } from "../../components/Pricing";
import { WhyIntelead } from "../../components/WhyIntelead";
import "./style.css";

export const Desktop = () => {
  const screenWidth = useWindowWidth();

  return (
    <div className="desktop">
      <div
        className="mobile"
        style={{
          height:
            screenWidth < 834
              ? "9005px"
              : screenWidth >= 834 && screenWidth < 1440
              ? "6759px"
              : screenWidth >= 1440
              ? "5812px"
              : undefined,
          overflow: screenWidth >= 1440 ? "hidden" : undefined,
          width:
            screenWidth < 834
              ? "402px"
              : screenWidth >= 834 && screenWidth < 1440
              ? "834px"
              : screenWidth >= 1440
              ? "1440px"
              : undefined,
        }}
      >
        {screenWidth >= 834 && screenWidth < 1440 && (
          <div className="frame-2">
            <img className="intelead-logo" alt="Intelead logo" src="/img/intelead-logo-2.png" />
            <div className="frame-3">
              <NavSolutions className="nav-solutions-instance" />
              <NavWhyIntelead className="nav-why-intelead-instance" />
              <NavPricing className="nav-pricing-instance" />
              <NavComparison className="nav-comparison-instance" />
            </div>
            <div className="frame-4">
              <NavLogin className="instance-node" />
              <NavFreeTrial className="instance-node" majesticonsOpen="/img/majesticons-open-line-2.png" />
            </div>
          </div>
        )}

        <div
          className="frame-5"
          style={{
            height:
              screenWidth >= 834 && screenWidth < 1440
                ? "183px"
                : screenWidth >= 1440
                ? "686px"
                : screenWidth < 834
                ? "799px"
                : undefined,
            left:
              screenWidth >= 834 && screenWidth < 1440
                ? "68px"
                : screenWidth >= 1440 || screenWidth < 834
                ? "0"
                : undefined,
            top:
              screenWidth >= 834 && screenWidth < 1440
                ? "132px"
                : screenWidth >= 1440
                ? "115px"
                : screenWidth < 834
                ? "107px"
                : undefined,
            width:
              screenWidth >= 834 && screenWidth < 1440
                ? "698px"
                : screenWidth >= 1440
                ? "1533px"
                : screenWidth < 834
                ? "402px"
                : undefined,
          }}
        >
          {screenWidth >= 834 && screenWidth < 1440 && (
            <div className="vector-wrapper">
              <img className="vector-19" alt="Vector" src="/img/vector-5-2.png" />
            </div>
          )}

          {(screenWidth >= 1440 || screenWidth < 834) && (
            <Component
              className={`${screenWidth >= 1440 && "class"} ${screenWidth < 834 && "class-2"}`}
              component={
                screenWidth >= 1440 ? "/img/component-10.png" : screenWidth < 834 ? "/img/component-9-1.png" : undefined
              }
            />
          )}

          {screenWidth >= 1440 && (
            <div className="frame-6">
              <div className="frame-7">
                <img
                  className="img-2"
                  alt="Never worry about"
                  src="/img/never-worry-about-finding-b2b-customers-again.png"
                />
                <p className="scrape-thousands-of">
                  <span className="span">Scrape thousands of triple-verified email adresses and </span>
                  <span className="text-wrapper-25">
                    create fully customized emails for each of your leads with a few clicks.
                  </span>
                </p>
                <div className="frame-8">
                  <div className="text-wrapper-26">Enter Your Business Email</div>
                  <Frame className="frame-112" divClassName="frame-instance" />
                </div>
                <div className="frame-9">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group-3">
                      <img className="download" alt="Download" src="/img/download-1.png" />
                      <img className="download-2" alt="Download" src="/img/download-1-1.png" />
                      <img className="download-3" alt="Download" src="/img/download-2-1.png" />
                      <img className="download-4" alt="Download" src="/img/download-3-1.png" />
                    </div>
                  </div>
                  <p className="element-satisfied">
                    <span className="text-wrapper-27">120+</span>
                    <span className="text-wrapper-28"> Satisfied Business Owners</span>
                  </p>
                  <img className="vector-20" alt="Vector" src="/img/vector-32.png" />
                </div>
                <div className="frame-10">
                  <div className="frame-11">
                    <p className="GDPR-CCPA-complient">
                      <span className="text-wrapper-27">GDPR</span>
                      <span className="text-wrapper-29"> &amp; </span>
                      <span className="text-wrapper-27">CCPA </span>
                      <span className="text-wrapper-29">Complient</span>
                    </p>
                    <img className="gg-check-o" alt="Gg check o" src="/img/gg-check-o.png" />
                  </div>
                  <div className="frame-12">
                    <p className="advanced">
                      <span className="text-wrapper-27">Advanced</span>
                      <span className="text-wrapper-29"> verification tech</span>
                    </p>
                    <img className="gg-check-o" alt="Gg check o" src="/img/gg-check-o.png" />
                  </div>
                </div>
              </div>
              <img className="component-3" alt="Component" src="/img/component-5-1.png" />
            </div>
          )}

          {screenWidth < 834 && (
            <>
              <div className="frame-13">
                <div className="frame-14">
                  <div className="img-wrapper">
                    <img className="vector-21" alt="Vector" src="/img/vector-5-1.png" />
                  </div>
                </div>
                <p className="scrape-thousands-of-2">
                  <span className="text-wrapper-30">Scrape thousands of triple-verified email adresses and </span>
                  <span className="text-wrapper-25">
                    create fully customized emails for each of your leads with a few clicks.
                  </span>
                </p>
                <div className="frame-15">
                  <input className="enter-your-business" />
                  <Frame className="frame-112-instance" divClassName="frame-instance" />
                </div>
                <GetADemo className="instance-node" property1="default" />
                <div className="frame-16">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group-3">
                      <img className="download" alt="Download" src="/img/download-1.png" />
                      <img className="download-2" alt="Download" src="/img/download-1-1.png" />
                      <img className="download-3" alt="Download" src="/img/download-2-1.png" />
                      <img className="download-4" alt="Download" src="/img/download-3-1.png" />
                    </div>
                  </div>
                  <p className="element-satisfied">
                    <span className="text-wrapper-27">120+</span>
                    <span className="text-wrapper-28"> Satisfied Business Owners</span>
                  </p>
                  <img className="vector-20" alt="Vector" src="/img/vector-60.png" />
                </div>
                <div className="frame-17">
                  <div className="frame-11">
                    <p className="GDPR-CCPA-complient">
                      <span className="text-wrapper-27">GDPR</span>
                      <span className="text-wrapper-29"> &amp; </span>
                      <span className="text-wrapper-27">CCPA </span>
                      <span className="text-wrapper-29">Complient</span>
                    </p>
                    <img className="gg-check-o" alt="Gg check o" src="/img/gg-check-o-2.png" />
                  </div>
                  <div className="frame-12">
                    <p className="advanced">
                      <span className="text-wrapper-27">Advanced</span>
                      <span className="text-wrapper-29"> verification tech</span>
                    </p>
                    <img className="gg-check-o" alt="Gg check o" src="/img/gg-check-o-2.png" />
                  </div>
                </div>
              </div>
              <div className="overlap-wrapper">
                <div className="overlap">
                  <img className="IMG" alt="Img" src="/img/img-1340-2.png" />
                  <img className="vector-22" alt="Vector" src="/img/vector-19-1.png" />
                  <img className="vector-23" alt="Vector" src="/img/vector-20-1.png" />
                  <img className="vector-24" alt="Vector" src="/img/vector-61.png" />
                  <img className="group-2" alt="Group" src="/img/group-3-2.png" />
                  <img className="group-3" alt="Group" src="/img/group-4.png" />
                  <img className="vector-25" alt="Vector" src="/img/vector-62.png" />
                  <img className="vector-26" alt="Vector" src="/img/vector-63.png" />
                  <img className="vector-27" alt="Vector" src="/img/vector-64.png" />
                  <img className="vector-28" alt="Vector" src="/img/vector-65.png" />
                  <img className="vector-29" alt="Vector" src="/img/vector-66.png" />
                  <img className="vector-30" alt="Vector" src="/img/vector-67.png" />
                  <img className="vector-31" alt="Vector" src="/img/vector-68.png" />
                  <img className="vector-32" alt="Vector" src="/img/vector-69.png" />
                  <img className="vector-33" alt="Vector" src="/img/vector-70.png" />
                  <img className="vector-34" alt="Vector" src="/img/vector-71.png" />
                </div>
              </div>
            </>
          )}
        </div>
        {screenWidth >= 834 && screenWidth < 1440 && (
          <>
            <p className="scrape-thousands-of-3">
              <span className="text-wrapper-31">Scrape thousands of triple-verified email adresses and</span>
              <span className="text-wrapper-32">&nbsp;</span>
              <span className="text-wrapper-25">
                create fully customized emails for each of your leads with a few clicks.
              </span>
            </p>
            <div className="frame-18">
              <div className="text-wrapper-33">Enter Your Business Email</div>
              <Frame className="frame-19" divClassName="frame-20" />
            </div>
          </>
        )}

        {((screenWidth >= 834 && screenWidth < 1440) || screenWidth < 834) && (
          <div
            className="frame-21"
            style={{
              height: screenWidth < 834 ? "33px" : screenWidth >= 834 && screenWidth < 1440 ? "684px" : undefined,
              left: screenWidth < 834 ? "17px" : screenWidth >= 834 && screenWidth < 1440 ? "0" : undefined,
              top: screenWidth < 834 ? "13px" : screenWidth >= 834 && screenWidth < 1440 ? "451px" : undefined,
              width: screenWidth < 834 ? "369px" : screenWidth >= 834 && screenWidth < 1440 ? "834px" : undefined,
            }}
          >
            {screenWidth < 834 && (
              <div className="frame-22">
                <NavFreeTrial className="nav-free-trial-instance" />
                <HamburgerMenu
                  className="instance-node-2"
                  property1="default"
                  propertyDefault="/img/hamburger-menu.png"
                />
              </div>
            )}

            {screenWidth >= 834 && screenWidth < 1440 && (
              <>
                <GetADemo className="get-a-demo-2" divClassName="get-a-demo-instance" property1="default" />
                <div className="frame-23">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group-3">
                      <img className="download" alt="Download" src="/img/download-1.png" />
                      <img className="download-2" alt="Download" src="/img/download-1-1.png" />
                      <img className="download-3" alt="Download" src="/img/download-2-1.png" />
                      <img className="download-4" alt="Download" src="/img/download-3-1.png" />
                    </div>
                  </div>
                  <p className="element-satisfied">
                    <span className="text-wrapper-27">120+</span>
                    <span className="text-wrapper-28"> Satisfied Business Owners</span>
                  </p>
                  <img className="vector-20" alt="Vector" src="/img/vector-98.png" />
                </div>
                <div className="frame-24">
                  <div className="frame-11">
                    <p className="GDPR-CCPA-complient">
                      <span className="text-wrapper-27">GDPR</span>
                      <span className="text-wrapper-29"> &amp; </span>
                      <span className="text-wrapper-27">CCPA </span>
                      <span className="text-wrapper-29">Complient</span>
                    </p>
                    <img className="gg-check-o" alt="Gg check o" src="/img/gg-check-o-2.png" />
                  </div>
                  <div className="frame-12">
                    <p className="advanced">
                      <span className="text-wrapper-27">Advanced</span>
                      <span className="text-wrapper-29"> verification tech</span>
                    </p>
                    <img className="gg-check-o" alt="Gg check o" src="/img/gg-check-o-2.png" />
                  </div>
                </div>
                <Component className="component-5" component="/img/component-11-1.png" />
              </>
            )}

            <img
              className="frame-25"
              style={{
                height: screenWidth < 834 ? "24px" : screenWidth >= 834 && screenWidth < 1440 ? "435px" : undefined,
                left: screenWidth < 834 ? "3px" : screenWidth >= 834 && screenWidth < 1440 ? "54px" : undefined,
                top: screenWidth < 834 ? "5px" : screenWidth >= 834 && screenWidth < 1440 ? "157px" : undefined,
                width: screenWidth < 834 ? "100px" : screenWidth >= 834 && screenWidth < 1440 ? "735px" : undefined,
              }}
              alt="Frame"
              src={
                screenWidth < 834
                  ? "/img/frame-75.png"
                  : screenWidth >= 834 && screenWidth < 1440
                  ? "/img/component-11-4.png"
                  : undefined
              }
            />
          </div>
        )}

        {screenWidth >= 834 && screenWidth < 1440 && (
          <>
            <div className="frame-26">
              <div className="frame-27">
                <p className="div-2">
                  <span className="text-wrapper-34">
                    Need to find verified emails to do outreach for your business?{" "}
                  </span>
                  <span className="text-wrapper-35">Done.</span>
                </p>
                <p className="div-3">
                  <span className="text-wrapper-36">
                    We do cold outreach as well; so we know the intricacies of email marketing. Unlike other lead
                    scrapers &amp; databases, we{" "}
                  </span>
                  <span className="text-wrapper-37">actually verify</span>
                  <span className="text-wrapper-36"> the emails we find. </span>
                </p>
              </div>
              <DivWrapper
                className="component-6"
                faSolidCheck="/img/fa-solid-check-circle-2.png"
                img="/img/vector-100.png"
                materialSymbols="/img/material-symbols-search-2.png"
                vector="/img/vector-99.png"
                vector1="/img/vector-101.png"
                vector2="/img/vector-102.png"
                vector3="/img/vector-9-3.png"
                vector4="/img/vector-10-3.png"
                vector5="/img/vector-11-3.png"
                vector6="/img/vector-12-3.png"
              />
              <div className="frame-28">
                <img className="vector-35" alt="Vector" src="/img/vector-37.png" />
                <p className="state-of-the-art">
                  State-of-the-art technology&nbsp;&nbsp;delicately verifying each email.
                </p>
                <img className="vector-36" alt="Vector" src="/img/vector-104.png" />
                <p className="text-wrapper-38">No more burned domains and damaged deliverability.</p>
                <img className="vector-37" alt="Vector" src="/img/vector-105.png" />
                <p className="text-wrapper-39">Reduced bounce rates, better outreach performance.</p>
              </div>
            </div>
            <div className="frame-29">
              <div className="frame-30">
                <p className="div-2">
                  <span className="text-wrapper-34">We thought you might need some extra information as well. </span>
                  <span className="text-wrapper-35">Done.</span>
                </p>
                <p className="div-3">
                  When you scrape a location, we not only provide the company&#39;s phone numbers but also their social
                  media profiles for a complete contact solution.
                </p>
              </div>
              <img className="component-4" alt="Component" src="/img/component-9-1-1.png" />
              <div className="frame-31">
                <div className="frame-32">
                  <p className="text-wrapper-40">Use the phone number for cold calling or sms outreach.</p>
                  <img className="vector-38" alt="Vector" src="/img/vector-106.png" />
                </div>
                <div className="frame-33">
                  <p className="text-wrapper-41">Export the social media profile urls to automate the DM outreach.</p>
                  <img className="vector-39" alt="Vector" src="/img/vector-107.png" />
                </div>
              </div>
            </div>
            <div className="frame-34">
              <div className="frame-35">
                <p className="div-2">
                  <span className="text-wrapper-34">
                    More importantly, we wanted to completely eliminate generic personalizations.{" "}
                  </span>
                  <span className="text-wrapper-35">Done.</span>
                </p>
                <p className="div-3">
                  InteLead is able to create unique emails for each lead that you are scraping based on your prompt. You
                  have full control over the tone, formality, and even the compliments used. Say goodbye to
                  one-size-fits-all customizations!
                </p>
              </div>
              <ComponentWrapper className="instance-node-2" component="/img/component-11.png" />
              <div className="frame-36">
                <img className="vector-40" alt="Vector" src="/img/vector-48.png" />
                <p className="text-wrapper-42">
                  No more risking domain blacklisting by sending the same email to thousands of people.
                </p>
                <img className="vector-41" alt="Vector" src="/img/vector-49.png" />
                <p className="say-goodbye-to">
                  Say goodbye to getting detected by the ESP servers <br />
                  as SPAM.
                </p>
                <img className="vector-42" alt="Vector" src="/img/vector-50.png" />
                <p className="text-wrapper-43">
                  Drastically improved response rate due to advanced personalization algorithm.
                </p>
              </div>
            </div>
            <div className="frame-37">
              <div className="SIX-STEP-CUSTOMER">
                SIX STEP <br />
                CUSTOMER ACQUISITON
              </div>
              <div className="frame-38">
                <div className="overlap-group-4">
                  <img className="vector-43" alt="Vector" src="/img/vector-21-1.png" />
                  <div className="rectangle-12" />
                  <div className="rectangle-13" />
                  <p className="text-wrapper-44">Enter your prompt and decide on the tonality.</p>
                  <div className="div-4" />
                  <div className="rectangle-14" />
                  <div className="rectangle-15" />
                  <p className="mass-send-targeted">Mass send targeted custom emails &amp; messages.</p>
                  <div className="rectangle-16" />
                  <p className="text-wrapper-45">Pick your industry and location.</p>
                  <p className="text-wrapper-46">Decide what features you want to use.</p>
                  <img className="vector-44" alt="Vector" src="/img/vector-111.png" />
                  <img
                    className="pajamas-feature-flag"
                    alt="Pajamas feature flag"
                    src="/img/pajamas-feature-flag-2.png"
                  />
                  <img className="fluent-prompt" alt="Fluent prompt" src="/img/fluent-prompt-16-filled-2.png" />
                  <img className="gg-export" alt="Gg export" src="/img/gg-export-2.png" />
                  <img
                    className="fluent-arrow-enter"
                    alt="Fluent arrow enter"
                    src="/img/fluent-arrow-enter-16-filled-2.png"
                  />
                  <img className="ic-round-send" alt="Ic round send" src="/img/ic-round-send-2.png" />
                  <p className="export-your-lead">Export your lead list with custom emails &amp; messages.</p>
                  <p className="text-wrapper-47">Import your list to your favorite outreach software.</p>
                </div>
              </div>
            </div>
            <div className="frame-39">
              <div className="frame-40">
                <div className="text-wrapper-48">Flexible Subscription System</div>
                <p className="text-wrapper-49">
                  Choose the one that suits you the best, top-up your credits whenever you need some.
                </p>
              </div>
              <div className="frame-41">
                <div className="frame-42">
                  <div className="overlap-group-5">
                    <div className="overlap-2">
                      <p className="want-to-use-all">
                        <span className="text-wrapper-27">
                          Want to use all?
                          <br />
                        </span>
                        <span className="text-wrapper-31">
                          {"  "}
                          <br />
                          Access web scraping, email validation, and custom email/message generation in one complete
                          package.
                        </span>
                      </p>
                      <div className="rectangle-17" />
                    </div>
                    <div className="text-wrapper-50">FULL ACCESS</div>
                  </div>
                </div>
                <div className="frame-43">
                  <div className="overlap-3">
                    <div className="overlap-group-6">
                      <p className="prefer-using-just">
                        <span className="text-wrapper-25">Prefer using just one? </span>
                        <span className="text-wrapper-31">
                          {"  "}Select web scraping, email validation, or custom email/message generation based on your
                          needs.
                        </span>
                      </p>
                      <div className="rectangle-18" />
                    </div>
                    <div className="PICK-CHOOSE">PICK &amp; CHOOSE</div>
                  </div>
                </div>
                <div className="frame-44">
                  <div className="overlap-4">
                    <div className="overlap-group-7">
                      <p className="out-of-credits">
                        <span className="text-wrapper-51">
                          Out of credits?  <br />
                          <br />
                          <br />
                          <br />
                        </span>
                        <span className="text-wrapper-52">
                          Easily add more credits with our top-up feature, no new subscription required.
                        </span>
                      </p>
                      <div className="rectangle-19" />
                    </div>
                    <div className="text-wrapper-53">TOP-UP</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-wrapper">
              <div className="frame-45">
                <div className="text-wrapper-54">Listen to Our Customers!</div>
                <div className="frame-46">
                  <div className="frame-47">
                    <div className="overlap-group-8">
                      <img className="vector-45" alt="Vector" src="/img/vector-112.png" />
                      <img className="img-3" alt="Unsplash" src="/img/unsplash-0zx1bdv5bny-2.png" />
                    </div>
                    <div className="frame-48">
                      <p className="div-5">
                        <span className="text-wrapper-25">Sarah M.,</span>
                        <span className="text-wrapper-55"> Marketing Director</span>
                      </p>
                      <p className="text-wrapper-56">
                        Intelead has completely transformed our outreach strategy! It’s clear that a lot of thought and
                        effort went into developing this software.
                      </p>
                    </div>
                  </div>
                  <div className="frame-47">
                    <div className="overlap-5">
                      <img className="vector-45" alt="Vector" src="/img/vector-112.png" />
                      <img className="img-3" alt="Unsplash" src="/img/unsplash-hwc7eiqitce-2.png" />
                    </div>
                    <div className="frame-49">
                      <p className="div-5">
                        <span className="text-wrapper-25">David L., </span>
                        <span className="text-wrapper-55">Sales Manager</span>
                      </p>
                      <p className="text-wrapper-56">
                        I was blown away by how easy Intelead is to use! The software pulled leads we couldn’t find
                        anywhere else and the custom email generation saved us hours of work.
                      </p>
                    </div>
                  </div>
                  <div className="frame-47">
                    <div className="overlap-5">
                      <img className="vector-45" alt="Vector" src="/img/vector-112.png" />
                      <img className="img-3" alt="Unsplash" src="/img/unsplash-swi1dgrcshq-2.png" />
                    </div>
                    <div className="frame-50">
                      <p className="div-5">
                        <span className="text-wrapper-25">Jennifer R., </span>
                        <span className="text-wrapper-55">Growth Strategist</span>
                      </p>
                      <p className="text-wrapper-56">
                        The most impressive part of Intelead is its ability to generate unique, relevant emails
                        automatically. It’s a powerful tool for anyone in marketing or sales.
                      </p>
                    </div>
                  </div>
                  <div className="frame-47">
                    <div className="overlap-5">
                      <img className="vector-45" alt="Vector" src="/img/vector-112.png" />
                      <img className="img-3" alt="Unsplash ivm" src="/img/unsplash-pata8xe-ivm-2.png" />
                    </div>
                    <div className="frame-51">
                      <p className="div-5">
                        <span className="text-wrapper-25">Mike T., </span>
                        <span className="text-wrapper-55">Business Development Lead</span>
                      </p>
                      <p className="text-wrapper-56">
                        Intelead has revolutionized our lead generation process. The leads are always fresh, and the
                        AI-generated messages are spot-on. It’s become an essential part of our toolkit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-52">
              <img
                className="img-2"
                alt="Lead scraping and"
                src="/img/lead-scraping-and-custom-messaging-in-one-software-2.png"
              />
              <img className="component-inte" alt="Component inte" src="/img/component-inte-2-2.png" />
              <div className="frame-53">
                <div className="frame-54">
                  <img className="img-4" alt="Database" src="/img/database-2.png" />
                  <div className="frame-55">
                    <p className="text-wrapper-57">
                      We are not a database. We scrape fresh leads based on your request.
                    </p>
                    <p className="text-wrapper-58">
                      Unlike outdated databases, we provide fresh leads by scraping the most up-to-date information
                      based on your request date.
                    </p>
                  </div>
                </div>
                <div className="frame-56">
                  <img className="img-4" alt="Loader" src="/img/loader-2.png" />
                  <div className="frame-57">
                    <p className="text-wrapper-59">
                      Being able to pull Google reviews for hundreds of companies provides a powerful competitive
                      advantage.
                    </p>
                    <p className="text-wrapper-58">
                      We leverage Google reviews to fuel our AI system, generating highly relatable and accurate emails
                      and messages.
                    </p>
                  </div>
                </div>
                <div className="frame-56">
                  <img className="img-4" alt="Map" src="/img/map-2.png" />
                  <div className="frame-58">
                    <p className="text-wrapper-57">
                      We can uncover businesses that don&#39;t appear in standard Google Maps searches.
                    </p>
                    <p className="text-wrapper-60">
                      Finding businesses that are difficult to locate through regular searches can give you a
                      competitive edge by allowing you to connect with prospects your competitors might miss.
                    </p>
                  </div>
                </div>
                <div className="frame-59">
                  <img className="img-5" alt="Shield" src="/img/shield-2.png" />
                  <div className="frame-60">
                    <p className="text-wrapper-61">
                      We significantly reduce the biggest challenge of email outreach: the risk of getting blacklisted.
                    </p>
                    <p className="text-wrapper-58">
                      While getting blacklisted depends on various factors, one of the most common is sending the same
                      email to thousands of companies. Eliminating this by crafting fully unique emails for each lead is
                      a game changer.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="overlap-6">
              <div className="frame-61">
                <p className="text-wrapper-62">Level-Up Your Outreach Efforts with InteLead Today!</p>
                <p className="text-wrapper-63">Experience immediate improvements in your marketing results.</p>
                <FtbAnima className="instance-node" property1="default" vector="/img/vector.png" />
              </div>
            </div>
          </>
        )}

        {(screenWidth >= 1440 || (screenWidth >= 834 && screenWidth < 1440)) && (
          <div
            className="frame-62"
            style={{
              gap: screenWidth >= 834 && screenWidth < 1440 ? "32px" : screenWidth >= 1440 ? "179px" : undefined,
              left: screenWidth >= 834 && screenWidth < 1440 ? "48px" : screenWidth >= 1440 ? "193px" : undefined,
              top: screenWidth >= 834 && screenWidth < 1440 ? "6506px" : screenWidth >= 1440 ? "21px" : undefined,
            }}
          >
            {screenWidth >= 834 && screenWidth < 1440 && (
              <div className="frame-63">
                <img className="vector-46" alt="Vector" src="/img/vector-117.svg" />
                <img className="img-5" alt="Frame" src="/img/frame-65.png" />
                <p className="copyright">
                  © Copyright 2024. InteLead. <br />
                  All rights reserved.
                </p>
              </div>
            )}

            {screenWidth >= 1440 && (
              <img className="intelead-logo" alt="Intelead logo" src="/img/intelead-logo-2.png" />
            )}

            <div
              className="frame-64"
              style={{
                alignItems:
                  screenWidth >= 834 && screenWidth < 1440 ? "flex-start" : screenWidth >= 1440 ? "center" : undefined,
                gap: screenWidth >= 834 && screenWidth < 1440 ? "46px" : screenWidth >= 1440 ? "42px" : undefined,
              }}
            >
              {screenWidth >= 834 && screenWidth < 1440 && (
                <>
                  <div className="frame-65">
                    <Contacts className="instance-node" />
                    <Login className="login-instance" divClassName="login-2" />
                    <FreeTrial className="instance-node" />
                  </div>
                  <div className="frame-66">
                    <Pricing className="instance-node" />
                    <Comparison className="instance-node" />
                    <WhyIntelead className="why-intelead-instance" />
                  </div>
                  <div className="frame-67">
                    <BookADemo className="instance-node" />
                    <ExploreOther className="instance-node" />
                  </div>
                </>
              )}

              {screenWidth >= 1440 && (
                <>
                  <NavSolutions className="nav-solutions-instance" />
                  <NavWhyIntelead className="nav-why-intelead-instance" />
                  <NavPricing className="nav-pricing-instance" />
                  <NavComparison className="nav-comparison-instance" />
                </>
              )}
            </div>
            {screenWidth >= 1440 && (
              <div className="frame-4">
                <NavLogin className="instance-node" />
                <NavFreeTrial className="instance-node" majesticonsOpen="/img/majesticons-open-line-2.png" />
              </div>
            )}
          </div>
        )}

        {screenWidth >= 1440 && (
          <>
            <div className="frame-68">
              <img
                className="need-to-find"
                alt="Need to find"
                src="/img/need-to-find-verified-emails-to-do-outreach-for-your-business-d.png"
              />
              <p className="we-do-cold-outreach">
                <span className="text-wrapper-36">
                  We do cold outreach as well; so we know the intricacies of email marketing. Unlike other lead scrapers
                  &amp; databases, we{" "}
                </span>
                <span className="text-wrapper-37">actually verify</span>
                <span className="text-wrapper-36"> the emails we find. </span>
              </p>
              <DivWrapper
                className="component-instance"
                faSolidCheck="/img/fa-solid-check-circle-1.png"
                img="/img/vector-34.png"
                materialSymbols="/img/material-symbols-search-1.png"
                vector="/img/vector-33.png"
                vector1="/img/vector-35.png"
                vector2="/img/vector-36.png"
                vector3="/img/vector-9-2.png"
                vector4="/img/vector-10-2.png"
                vector5="/img/vector-11-2.png"
                vector6="/img/vector-12-2.png"
              />
              <div className="frame-69">
                <img className="vector-35" alt="Vector" src="/img/vector-37.png" />
                <p className="text-wrapper-64">
                  State-of-the-art technology&nbsp;&nbsp;delicately verifying each email.
                </p>
                <img className="vector-36" alt="Vector" src="/img/vector-38.png" />
                <p className="text-wrapper-65">No more burned domains and damaged deliverability.</p>
                <img className="vector-37" alt="Vector" src="/img/vector-39.png" />
                <p className="text-wrapper-66">Reduced bounce rates, better outreach performance.</p>
              </div>
            </div>
            <div className="frame-70">
              <p className="we-thought-you-might">
                <span className="text-wrapper-34">We thought you might need some extra information as well. </span>
                <span className="text-wrapper-35">Done.</span>
              </p>
              <Component2
                className="component-2-instance"
                group="/img/group-3-1.png"
                img="/img/vector-43.png"
                rectangle="/img/rectangle-82-1.png"
                vector="/img/vector-42.png"
                vector1="/img/vector-44.png"
                vector2="/img/vector-45.png"
                vector3="/img/vector-13-1.png"
                vector4="/img/vector-46.png"
                vector5="/img/vector-47.png"
              />
              <p className="when-you-scrape-a">
                When you scrape a location, we not only provide the company&#39;s phone numbers but also their social
                media profiles for a complete contact solution.
              </p>
              <p className="text-wrapper-67">Use the phone number for cold calling or sms outreach.</p>
              <p className="text-wrapper-68">Export the social media profile urls to automate the DM outreach.</p>
              <img className="vector-47" alt="Vector" src="/img/vector-40.png" />
              <img className="vector-48" alt="Vector" src="/img/vector-41.png" />
            </div>
            <div className="frame-71">
              <div className="overlap-7">
                <p className="more-importantly-we">
                  <span className="text-wrapper-34">
                    More importantly, we wanted to completely eliminate generic personalizations.{" "}
                  </span>
                  <span className="text-wrapper-35">Done.</span>
                </p>
                <ComponentWrapper className="component-3-instance" component="/img/component-4.png" />
              </div>
              <p className="text-wrapper-69">
                InteLead is able to create unique emails for each lead that you are scraping based on your prompt. You
                have full control over the tone, formality, and even the compliments used. Say goodbye to
                one-size-fits-all customizations!
              </p>
              <div className="frame-72">
                <img className="vector-40" alt="Vector" src="/img/vector-48.png" />
                <p className="text-wrapper-64">
                  No more risking domain blacklisting by sending the same email to thousands of people.
                </p>
                <img className="vector-41" alt="Vector" src="/img/vector-49.png" />
                <p className="text-wrapper-65">Say goodbye to getting detected by the ESP servers as SPAM.</p>
                <img className="vector-42" alt="Vector" src="/img/vector-50.png" />
                <p className="text-wrapper-70">
                  Drastically improved response rate due to advanced personalization algorithm.
                </p>
              </div>
            </div>
            <div className="frame-73">
              <div className="frame-38">
                <div className="overlap-group-4">
                  <img className="vector-43" alt="Vector" src="/img/vector-21-1.png" />
                  <div className="rectangle-12" />
                  <div className="rectangle-13" />
                  <p className="text-wrapper-44">Enter your prompt and decide on the tonality.</p>
                  <div className="div-4" />
                  <div className="rectangle-14" />
                  <div className="rectangle-15" />
                  <p className="mass-send-targeted">Mass send targeted custom emails &amp; messages.</p>
                  <div className="rectangle-16" />
                  <p className="text-wrapper-45">Pick your industry and location.</p>
                  <p className="text-wrapper-46">Decide what features you want to use.</p>
                  <img className="vector-44" alt="Vector" src="/img/vector-51.png" />
                  <img
                    className="pajamas-feature-flag"
                    alt="Pajamas feature flag"
                    src="/img/pajamas-feature-flag.png"
                  />
                  <img className="fluent-prompt" alt="Fluent prompt" src="/img/fluent-prompt-16-filled.png" />
                  <img className="gg-export" alt="Gg export" src="/img/gg-export.png" />
                  <img
                    className="fluent-arrow-enter"
                    alt="Fluent arrow enter"
                    src="/img/fluent-arrow-enter-16-filled.png"
                  />
                  <img className="ic-round-send" alt="Ic round send" src="/img/ic-round-send.png" />
                  <p className="export-your-lead">Export your lead list with custom emails &amp; messages.</p>
                  <p className="text-wrapper-47">Import your list to your favorite outreach software.</p>
                </div>
              </div>
              <div className="frame-74">
                <div className="SIX-STEP">
                  SIX
                  <br />
                  STEP
                </div>
                <div className="text-wrapper-71">CUSTOMER ACQUISITION</div>
              </div>
            </div>
            <div className="overlap-8">
              <div className="frame-75">
                <div className="frame-40">
                  <div className="text-wrapper-48">Flexible Subscription System</div>
                  <p className="text-wrapper-49">
                    Choose the one that suits you the best, top-up your credits whenever you need some.
                  </p>
                </div>
                <div className="frame-76">
                  <div className="frame-77">
                    <div className="overlap-group-9">
                      <p className="want-to-use-all-2">
                        <span className="text-wrapper-27">Want to use all?</span>
                        <span className="text-wrapper-31">
                          {"  "}
                          <br />
                        </span>
                        <span className="text-wrapper-72">
                          Access web scraping, email validation, and custom email/message generation in one complete
                          package.
                        </span>
                      </p>
                      <div className="rectangle-20" />
                    </div>
                    <div className="text-wrapper-73">FULL ACCESS</div>
                  </div>
                  <div className="frame-77">
                    <div className="overlap-9">
                      <p className="prefer-using-just-2">
                        <span className="text-wrapper-25">Prefer using just one? </span>
                        <span className="text-wrapper-31">{"  "}</span>
                        <span className="text-wrapper-72">
                          Select web scraping, email validation, or custom email/message generation based on your needs.
                        </span>
                      </p>
                      <div className="rectangle-20" />
                    </div>
                    <div className="PICK-CHOOSE-2">PICK &amp; CHOOSE</div>
                  </div>
                  <div className="frame-77">
                    <div className="overlap-9">
                      <p className="out-of-credits-2">
                        <span className="text-wrapper-51">
                          Out of credits?  <br />
                          <br />
                          <br />
                        </span>
                        <span className="text-wrapper-74">
                          Easily add more credits with our top-up feature, no new subscription required.
                        </span>
                      </p>
                      <div className="rectangle-20" />
                    </div>
                    <div className="text-wrapper-75">TOP-UP</div>
                  </div>
                </div>
              </div>
              <img className="component-7" alt="Component" src="/img/component-8.png" />
              <div className="frame-78">
                <div className="text-wrapper-76">Listen to Our Customers!</div>
                <div className="frame-79">
                  <div className="frame-80">
                    <div className="overlap-group-10">
                      <img className="vector-49" alt="Vector" src="/img/vector-52.png" />
                      <img className="img-6" alt="Unsplash" src="/img/unsplash-0zx1bdv5bny.png" />
                    </div>
                    <div className="frame-81">
                      <p className="div-6">
                        <span className="text-wrapper-25">Sarah M.,</span>
                        <span className="text-wrapper-77"> Marketing Director</span>
                      </p>
                      <p className="text-wrapper-78">
                        Intelead has completely transformed our outreach strategy! It’s clear that a lot of thought and
                        effort went into developing this software.
                      </p>
                    </div>
                  </div>
                  <div className="frame-80">
                    <div className="overlap-group-10">
                      <img className="vector-49" alt="Vector" src="/img/vector-52.png" />
                      <img className="img-6" alt="Unsplash" src="/img/unsplash-hwc7eiqitce.png" />
                    </div>
                    <div className="frame-81">
                      <p className="div-6">
                        <span className="text-wrapper-25">David L., </span>
                        <span className="text-wrapper-77">Sales Manager</span>
                      </p>
                      <p className="text-wrapper-78">
                        I was blown away by how easy Intelead is to use! The software pulled leads we couldn’t find
                        anywhere else and the custom email generation saved us hours of work.
                      </p>
                    </div>
                  </div>
                  <div className="frame-80">
                    <div className="overlap-group-10">
                      <img className="vector-49" alt="Vector" src="/img/vector-52.png" />
                      <img className="img-6" alt="Unsplash" src="/img/unsplash-swi1dgrcshq.png" />
                    </div>
                    <div className="frame-81">
                      <p className="div-6">
                        <span className="text-wrapper-25">Jennifer R., </span>
                        <span className="text-wrapper-77">Growth Strategist</span>
                      </p>
                      <p className="text-wrapper-78">
                        The most impressive part of Intelead is its ability to generate unique, relevant emails
                        automatically. It’s a powerful tool for anyone in marketing or sales.
                      </p>
                    </div>
                  </div>
                  <div className="frame-80">
                    <div className="overlap-group-10">
                      <img className="vector-49" alt="Vector" src="/img/vector-52.png" />
                      <img className="img-6" alt="Unsplash ivm" src="/img/unsplash-pata8xe-ivm.png" />
                    </div>
                    <div className="frame-81">
                      <p className="div-6">
                        <span className="text-wrapper-25">Mike T., </span>
                        <span className="text-wrapper-77">Business Development Lead</span>
                      </p>
                      <p className="text-wrapper-78">
                        Intelead has revolutionized our lead generation process. The leads are always fresh, and the
                        AI-generated messages are spot-on. It’s become an essential part of our toolkit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-82">
              <img
                className="lead-scraping-and"
                alt="Lead scraping and"
                src="/img/lead-scraping-and-custom-messaging-in-one-software.png"
              />
              <div className="frame-83">
                <div className="frame-84">
                  <img className="img-4" alt="Database" src="/img/database.png" />
                  <div className="frame-85">
                    <p className="text-wrapper-79">
                      We are not a database. We scrape fresh leads based on your request.
                    </p>
                    <p className="text-wrapper-80">
                      Unlike outdated databases, we provide fresh leads by scraping the most up-to-date information
                      based on your request date.
                    </p>
                  </div>
                </div>
                <div className="frame-86">
                  <img className="img-4" alt="Map" src="/img/map.png" />
                  <div className="frame-87">
                    <p className="we-can-uncover">
                      We can uncover businesses that don&#39;t appear in standard Google Maps searches.
                    </p>
                    <p className="text-wrapper-81">
                      Finding businesses that are difficult to locate through regular searches can give you a
                      competitive edge by allowing you to connect with prospects your competitors might miss.
                    </p>
                  </div>
                </div>
                <div className="frame-88">
                  <img className="img-4" alt="Loader" src="/img/loader.png" />
                  <div className="frame-89">
                    <p className="text-wrapper-82">
                      Being able to pull Google reviews for hundreds of companies provides a powerful competitive
                      advantage.
                    </p>
                    <p className="text-wrapper-83">
                      We leverage Google reviews to fuel our AI system, generating highly relatable and accurate emails
                      and messages.
                    </p>
                  </div>
                </div>
                <div className="frame-90">
                  <img className="img-4" alt="Shield" src="/img/shield.png" />
                  <div className="frame-91">
                    <p className="text-wrapper-82">
                      We significantly reduce the biggest challenge of email outreach: the risk of getting blacklisted.
                    </p>
                    <p className="text-wrapper-84">
                      While getting blacklisted depends on various factors, one of the most common is sending the same
                      email to thousands of companies. Eliminating this by crafting fully unique emails for each lead is
                      a game changer.
                    </p>
                  </div>
                </div>
                <img className="component-inte-2" alt="Component inte" src="/img/component-inte-2.png" />
              </div>
            </div>
            <div className="overlap-10">
              <div className="frame-92">
                <p className="text-wrapper-85">Level-Up Your Outreach Efforts with InteLead Today!</p>
                <p className="text-wrapper-63">Experience immediate improvements in your marketing results.</p>
                <FreeTrialButton
                  className="free-trial-button-end"
                  divClassName="free-trial-button-instance"
                  property1="default"
                  vectorClassName="free-trial-button-end-instance"
                />
              </div>
            </div>
            <div className="frame-93">
              <div className="frame-63">
                <img className="vector-46" alt="Vector" src="/img/vector-57.svg" />
                <img className="img-5" alt="Frame" src="/img/frame-65.png" />
                <p className="copyright">
                  © Copyright 2024. InteLead. <br />
                  All rights reserved.
                </p>
              </div>
              <div className="frame-94">
                <div className="frame-65">
                  <Contacts className="instance-node" />
                  <Login className="login-instance" divClassName="login-2" />
                  <FreeTrial className="instance-node" />
                </div>
                <div className="frame-66">
                  <Pricing className="instance-node" />
                  <Comparison className="instance-node" />
                  <WhyIntelead className="why-intelead-instance" />
                </div>
                <div className="frame-67">
                  <BookADemo className="instance-node" />
                  <ExploreOther className="instance-node" />
                </div>
              </div>
            </div>
          </>
        )}

        {screenWidth < 834 && (
          <>
            <div className="frame-95">
              <div className="frame-96">
                <img
                  className="img-2"
                  alt="Need to find"
                  src="/img/need-to-find-verified-emails-to-do-outreach-for-your-business-d-1.png"
                />
                <p className="div-7">
                  <span className="text-wrapper-86">
                    We do cold outreach as well; so we know the intricacies of email marketing. Unlike other lead
                    scrapers &amp; databases, we{" "}
                  </span>
                  <span className="text-wrapper-37">actually verify</span>
                  <span className="text-wrapper-86"> the emails we find. </span>
                </p>
              </div>
              <img className="component-8" alt="Component" src="/img/component-7-2.png" />
              <div className="frame-97">
                <div className="frame-98">
                  <img className="vector-50" alt="Vector" src="/img/vector-72.png" />
                  <p className="state-of-the-art-2">
                    State-of-the-art technology&nbsp;&nbsp;delicately verifying each email.
                  </p>
                </div>
                <div className="frame-99">
                  <img className="vector-51" alt="Vector" src="/img/vector-73.png" />
                  <p className="text-wrapper-87">No more burned domains and damaged deliverability.</p>
                </div>
                <div className="frame-100">
                  <img className="vector-50" alt="Vector" src="/img/vector-74.png" />
                  <p className="text-wrapper-88">Reduced bounce rates, better outreach performance.</p>
                </div>
              </div>
            </div>
            <div className="frame-101">
              <div className="frame-102">
                <p className="we-thought-you-might-2">
                  <span className="text-wrapper-34">We thought you might need some extra information as well. </span>
                  <span className="text-wrapper-35">Done.</span>
                </p>
                <p className="div-7">
                  When you scrape a location, we not only provide the company&#39;s phone numbers but also their social
                  media profiles for a complete contact solution.
                </p>
              </div>
              <img className="component-9" alt="Component" src="/img/component-9-2-1.png" />
              <div className="frame-103">
                <div className="frame-104">
                  <img className="vector-52" alt="Vector" src="/img/vector-75.png" />
                  <p className="text-wrapper-89">Use the phone number for cold calling or sms outreach.</p>
                </div>
                <div className="frame-104">
                  <img className="vector-52" alt="Vector" src="/img/vector-76.png" />
                  <p className="text-wrapper-64">Export the social media profile urls to automate the DM outreach.</p>
                </div>
              </div>
            </div>
            <div className="frame-105">
              <div className="frame-106">
                <p className="more-importantly-we-2">
                  <span className="text-wrapper-34">
                    More importantly, we wanted to completely eliminate generic personalizations.{" "}
                  </span>
                  <span className="text-wrapper-35">Done.</span>
                </p>
                <p className="div-7">
                  InteLead is able to create unique emails for each lead that you are scraping based on your prompt. You
                  have full control over the tone, formality, and even the compliments used. Say goodbye to
                  one-size-fits-all customizations!
                </p>
              </div>
              <ComponentWrapper className="component-10" component="/img/component-4-1.png" />
              <div className="frame-107">
                <div className="frame-108">
                  <img className="vector-52" alt="Vector" src="/img/vector-77.png" />
                  <p className="text-wrapper-90">
                    No more risking domain blacklisting by sending the same email to thousands of people.
                  </p>
                </div>
                <div className="frame-109">
                  <img className="vector-52" alt="Vector" src="/img/vector-78.png" />
                  <p className="text-wrapper-91">Say goodbye to getting detected by the ESP servers as SPAM.</p>
                </div>
                <div className="frame-110">
                  <img className="vector-52" alt="Vector" src="/img/vector-79.png" />
                  <p className="text-wrapper-92">
                    Drastically improved response rate due to advanced personalization algorithm.
                  </p>
                </div>
              </div>
            </div>
            <div className="frame-111">
              <div className="frame-113">
                <div className="text-wrapper-93">SIX STEP</div>
                <div className="text-wrapper-94">CUSTOMER ACQUISITION</div>
              </div>
              <div className="frame-114">
                <div className="overlap-group-11">
                  <img className="vector-53" alt="Vector" src="/img/vector-25-1.png" />
                  <div className="frame-115">
                    <p className="text-wrapper-95">Decide what features you want to use.</p>
                    <img className="img-7" alt="Pajamas feature flag" src="/img/pajamas-feature-flag-1.png" />
                  </div>
                  <div className="div-4">
                    <img className="vector-44" alt="Vector" src="/img/vector-80.png" />
                    <p className="text-wrapper-96">Pick your industry and location.</p>
                  </div>
                  <div className="frame-116">
                    <p className="text-wrapper-97">Enter your prompt and decide on the tonality.</p>
                    <img className="fluent-prompt-2" alt="Fluent prompt" src="/img/fluent-prompt-16-filled-1.png" />
                  </div>
                  <div className="frame-117">
                    <p className="mass-send-targeted-2">Mass send targeted custom emails &amp; messages.</p>
                    <img className="ic-round-send-2" alt="Ic round send" src="/img/ic-round-send-1.png" />
                  </div>
                  <div className="frame-118">
                    <img
                      className="fluent-arrow-enter-2"
                      alt="Fluent arrow enter"
                      src="/img/fluent-arrow-enter-16-filled-1.png"
                    />
                    <p className="text-wrapper-98">Import your list to your favorite outreach software.</p>
                  </div>
                  <div className="frame-119">
                    <img className="img-7" alt="Gg export" src="/img/gg-export-1.png" />
                    <p className="export-your-lead-2">Export your lead list with custom emails &amp; messages.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-120">
              <div className="frame-121">
                <div className="text-wrapper-99">Flexible Subscription</div>
                <p className="text-wrapper-100">
                  Choose the one that suits you the best, top-up your credits whenever you need some.
                </p>
              </div>
              <div className="frame-122">
                <div className="frame-77">
                  <div className="overlap-group-9">
                    <p className="want-to-use-all-2">
                      <span className="text-wrapper-27">Want to use all?</span>
                      <span className="text-wrapper-31">
                        {"  "}
                        <br />
                      </span>
                      <span className="text-wrapper-72">
                        Access web scraping, email validation, and custom email/message generation in one complete
                        package.
                      </span>
                    </p>
                    <div className="rectangle-20" />
                  </div>
                  <div className="text-wrapper-73">FULL ACCESS</div>
                </div>
                <div className="frame-123">
                  <div className="overlap-9">
                    <p className="prefer-using-just-2">
                      <span className="text-wrapper-25">Prefer using just one? </span>
                      <span className="text-wrapper-31">{"  "}</span>
                      <span className="text-wrapper-72">
                        Select web scraping, email validation, or custom email/message generation based on your needs.
                      </span>
                    </p>
                    <div className="rectangle-20" />
                  </div>
                  <div className="PICK-CHOOSE-2">PICK &amp; CHOOSE</div>
                </div>
                <div className="frame-123">
                  <div className="overlap-9">
                    <p className="out-of-credits-2">
                      <span className="text-wrapper-51">
                        Out of credits?  <br />
                        <br />
                        <br />
                      </span>
                      <span className="text-wrapper-74">
                        Easily add more credits with our top-up feature, no new subscription required.
                      </span>
                    </p>
                    <div className="rectangle-20" />
                  </div>
                  <div className="text-wrapper-75">TOP-UP</div>
                </div>
              </div>
            </div>
            <div className="overlap-11">
              <div className="text-wrapper-101">Listen to Our Customers!</div>
              <div className="frame-124">
                <div className="overlap-12">
                  <div className="frame-125">
                    <img className="unsplash" alt="Unsplash" src="/img/unsplash-0zx1bdv5bny-1.png" />
                    <div className="frame-126">
                      <p className="div-8">
                        <span className="text-wrapper-25">Sarah M.,</span>
                        <span className="text-wrapper-102"> Marketing Director</span>
                      </p>
                      <p className="text-wrapper-103">
                        Intelead has completely transformed our outreach strategy! It’s clear that a lot of thought and
                        effort went into developing this software.
                      </p>
                    </div>
                    <img className="vector-54" alt="Vector" src="/img/vector-81.png" />
                  </div>
                  <div className="frame-127">
                    <img className="unsplash" alt="Unsplash" src="/img/unsplash-hwc7eiqitce-1.png" />
                    <div className="frame-126">
                      <p className="div-8">
                        <span className="text-wrapper-25">David L., </span>
                        <span className="text-wrapper-102">Sales Manager</span>
                      </p>
                      <p className="text-wrapper-103">
                        I was blown away by how easy Intelead is to use! The software pulled leads we couldn’t find
                        anywhere else and the custom email generation saved us hours of work.
                      </p>
                    </div>
                    <img className="vector-55" alt="Vector" src="/img/vector-81.png" />
                  </div>
                  <div className="frame-128">
                    <img className="unsplash-swidgrcshq" alt="Unsplash" src="/img/unsplash-swi1dgrcshq-1.png" />
                    <div className="frame-126">
                      <p className="div-8">
                        <span className="text-wrapper-25">Jennifer R., </span>
                        <span className="text-wrapper-102">Growth Strategist</span>
                      </p>
                      <p className="text-wrapper-103">
                        The most impressive part of InteLead is its ability to generate unique, relevant emails
                        automatically. It’s a powerful tool for anyone in marketing or sales.
                      </p>
                    </div>
                    <img className="vector-55" alt="Vector" src="/img/vector-81.png" />
                  </div>
                  <div className="frame-129">
                    <img className="unsplash-ivm" alt="Unsplash ivm" src="/img/unsplash-pata8xe-ivm-1.png" />
                    <div className="frame-126">
                      <p className="div-8">
                        <span className="text-wrapper-25">Mike T., </span>
                        <span className="text-wrapper-102">Business Development Lead</span>
                      </p>
                      <p className="text-wrapper-103">
                        Intelead has revolutionized our lead generation process. The leads are always fresh, and the
                        AI-generated messages are spot-on. It’s become an essential part of our toolkit.
                      </p>
                    </div>
                    <img className="vector-55" alt="Vector" src="/img/vector-81.png" />
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-130">
              <img
                className="lead-scraping-and-2"
                alt="Lead scraping and"
                src="/img/lead-scraping-and-custom-messaging-in-one-software-1.png"
              />
              <img className="component-inte-3" alt="Component inte" src="/img/component-inte-2-1.png" />
              <div className="frame-131">
                <img className="img-4" alt="Database" src="/img/database-1.png" />
                <div className="frame-132">
                  <p className="text-wrapper-57">We are not a database. We scrape fresh leads based on your request.</p>
                  <p className="text-wrapper-104">
                    Unlike outdated databases, we provide fresh leads by scraping the most up-to-date information based
                    on your request date.
                  </p>
                </div>
              </div>
              <div className="frame-131">
                <img className="img-4" alt="Map" src="/img/map.png" />
                <div className="frame-133">
                  <p className="text-wrapper-57">
                    We can uncover businesses that don&#39;t appear in standard Google Maps searches.
                  </p>
                  <p className="text-wrapper-60">
                    Finding businesses that are difficult to locate through regular searches can give you a competitive
                    edge by allowing you to connect with prospects your competitors might miss.
                  </p>
                </div>
              </div>
              <div className="frame-131">
                <img className="img-4" alt="Loader" src="/img/loader.png" />
                <div className="frame-133">
                  <p className="text-wrapper-61">
                    Being able to pull Google reviews for hundreds of companies provides a powerful competitive
                    advantage.
                  </p>
                  <p className="text-wrapper-58">
                    We leverage Google reviews to fuel our AI system, generating highly relatable and accurate emails
                    and messages.
                  </p>
                </div>
              </div>
              <div className="frame-131">
                <img className="img-4" alt="Shield" src="/img/shield.png" />
                <div className="frame-133">
                  <p className="text-wrapper-61">
                    Being able to pull Google reviews for hundreds of companies provides a powerful competitive
                    advantage.
                  </p>
                  <p className="text-wrapper-58">
                    We leverage Google reviews to fuel our AI system, generating highly relatable and accurate emails
                    and messages.
                  </p>
                </div>
              </div>
            </div>
            <div className="overlap-13">
              <div className="frame-134">
                <p className="text-wrapper-85">Level-Up Your Outreach Efforts with InteLead Today!</p>
                <p className="text-wrapper-63">Experience immediate improvements in your marketing results.</p>
                <FtbAnima className="instance-node" property1="default" />
              </div>
            </div>
            <div className="frame-135">
              <div className="frame-136">
                <img className="vector-56" alt="Vector" src="/img/vector-86.svg" />
                <div className="overlap-group-12">
                  <div className="frame-137">
                    <Contacts className="instance-node-3" divClassName="contacts-instance" />
                    <Login className="login-3" divClassName="instance-node-4" />
                    <FreeTrial className="instance-node-5" divClassName="instance-node-4" />
                  </div>
                  <div className="frame-138">
                    <Pricing className="instance-node-6" divClassName="instance-node-7" />
                    <Comparison className="instance-node-6" divClassName="instance-node-7" />
                    <WhyIntelead className="instance-node-6" divClassName="instance-node-7" />
                  </div>
                </div>
                <div className="frame-139">
                  <BookADemo className="instance-node-3" divClassName="instance-node-8" />
                  <Comparison className="instance-node-3" divClassName="instance-node-8" />
                  <ExploreOther className="instance-node-5" divClassName="instance-node-8" />
                </div>
                <p className="text-wrapper-105">© Copyright 2024. InteLead. All rights reserved.</p>
              </div>
              <img className="frame-140" alt="Frame" src="/img/frame-65-1.png" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
